var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 7H15.9167C16.469 7 16.9167 7.44771 16.9167 8V10.8333C16.9167 10.9714 17.0286 11.0833 17.1667 11.0833H20C20.5523 11.0833 21 11.531 21 12.0833V15.9167C21 16.469 20.5523 16.9167 20 16.9167H17.1667C17.0286 16.9167 16.9167 17.0286 16.9167 17.1667V20C16.9167 20.5523 16.469 21 15.9167 21H12.0833C11.531 21 11.0833 20.5523 11.0833 20V17.1667C11.0833 17.0286 10.9714 16.9167 10.8333 16.9167H8C7.44772 16.9167 7 16.469 7 15.9167V12.0833C7 11.531 7.44771 11.0833 8 11.0833H10.8333C10.9714 11.0833 11.0833 10.9714 11.0833 10.8333V8C11.0833 7.44772 11.531 7 12.0833 7Z",
    stroke: "#050022",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4c5e1342c95e370154844c82212d8022.svg";
export { ForwardRef as ReactComponent };